import Api from "../../../Services/Api";

export const fetchDataItem = async (type, body) => {
    console.log(body);
    
    switch (type) {
        case "KSU" :
            try {
                const res = await Api.create("NAGAMAS_MASTER_DATA").getAllKSUPagingByParam({
                    paramFilters: {
                        category: body
                    }
                });

                return res.data.data?.map(item => ({
                    value: item.kodeKSU,
                    label: item.name,
                    satuan: item.satuanDTO?.value,
                }))
            } catch (error) {
                console.log("errors: ", error);
                return null;
            }
        case "Hadiah" :
            try {
                const res = await Api.create("NAGAMAS_MASTER_DATA").getAllHadiahPagingByParam({
                    paramFilters: {
                        categoryHadiah: body
                    }
                });

                return res.data.data?.map(item => ({
                    value: item.kodeHadiah,
                    label: item.nameHadiah,
                    satuan: item.satuanHadiah,
                }))
            } catch (error) {
                console.log("errors: ", error);
                return null;
            }
        case "OtherItem" :
            try {
                const res = await Api.create("NAGAMAS_MASTER_DATA").getAllOtherItemPagingByParam({
                    paramFilters: {
                        categoryotheritem: body
                    }
                });

                return res.data.data?.map(item => ({
                    value: item.kodeotheritem,
                    label: item.nameotheritem,
                    satuan: item.satuanotheritem,
                }))
            } catch (error) {
                console.log("errors: ", error);
                return null;
            }
        case "Part" :
            try {
                const res = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterPart({
                    paramFilters: {
                        partcategory: body
                    }
                });

                return res.data.data?.map(item => ({
                    value: item.kodePart,
                    label: item.partName,
                    satuan: item.satuan,
                }))
            } catch (error) {
                console.log("errors: ", error);
                return null;
            }
    }
}